/* Bandeau cookies Consentmo : « Continuer sans accepter » en lien souligné,
 * en haut à gauche du bandeau (01/10/2026).
 * Le bandeau vit dans le shadow DOM de <csm-cookie-consent> : le CSS du thème
 * ne l'atteint pas, on lui attache donc une feuille de style.
 * Si Consentmo change sa structure, le bouton reprend simplement sa place. */
(function () {
  'use strict';

  var B = '#csm-wrapper .csm-cookie-box-window .cc-compliance button.cc-btn.cc-deny';
  var CSS =
    '#csm-wrapper .csm-cookie-box-window{position:relative!important;padding-top:50px!important}' +
    B + ',' + B + ' *{font-weight:400!important;font-size:14px!important;line-height:1.3!important;color:#303030!important}' +
    B + '{position:absolute!important;top:10px!important;left:16px!important;width:auto!important;' +
    'min-width:0!important;min-height:0!important;height:auto!important;flex:none!important;' +
    'margin:0!important;padding:6px 0!important;background:transparent!important;border:0!important;' +
    'box-shadow:none!important;text-decoration:underline!important;text-underline-offset:3px;cursor:pointer}';

  function appliquer() {
    var hote = document.querySelector('csm-cookie-consent');
    var racine = hote && hote.shadowRoot;
    if (!racine) return false;
    if (racine.__pmLien) return true;
    try {
      var feuille = new CSSStyleSheet();
      feuille.replaceSync(CSS);
      racine.adoptedStyleSheets = Array.prototype.concat.call(racine.adoptedStyleSheets || [], [feuille]);
    } catch (e) {
      var style = document.createElement('style');
      style.textContent = CSS;
      racine.appendChild(style);
    }
    racine.__pmLien = true;
    return true;
  }

  if (appliquer()) return;
  // Le bandeau arrive après le chargement : on guette son apparition (30 s max).
  var essais = 0;
  var minuteur = setInterval(function () {
    if (appliquer() || ++essais > 120) clearInterval(minuteur);
  }, 250);
})();